import { FC, KeyboardEvent, useEffect, useRef, useState } from "react";
import Button from "../ui/Button";

type Props = {
  /** Resolves true when the code was checked; the field keeps it otherwise, so nothing has to be retyped. */
  onSubmit: (value: string) => Promise<boolean>;
  disabled?: boolean;
  autoFocus?: boolean;
  refocusKey?: number;
};

// Handheld barcode scanners type the code and press Enter, so a focused field is all they need. The same
// field takes a booking reference typed by hand when a QR cannot be read. On a phone the keyboard is put
// away after a check so it does not cover the answer.
const ScanInput: FC<Props> = ({ onSubmit, disabled, autoFocus, refocusKey }) => {
  const [value, setValue] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autoFocus) inputRef.current?.focus();
  }, [autoFocus, refocusKey]);

  const submit = async () => {
    const code = value.trim();
    if (!code || disabled) return;
    if (!autoFocus) inputRef.current?.blur();
    if (await onSubmit(code)) setValue("");
  };

  const onKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key !== "Enter") return;
    event.preventDefault();
    void submit();
  };

  return (
    <div className="flex gap-2">
      <input
        ref={inputRef}
        value={value}
        onChange={(event) => setValue(event.target.value)}
        onKeyDown={onKeyDown}
        placeholder="ID e rezervimit"
        aria-label="ID e rezervimit"
        autoComplete="off"
        autoCapitalize="off"
        spellCheck={false}
        className="h-11 min-w-0 flex-1 rounded-lg px-3 text-base outline-none ring-1 ring-blue-stroke
          focus:ring-primary"
      />
      <Button
        padding="px-4"
        className="h-11"
        onClick={() => void submit()}
        disabled={disabled || !value.trim()}
      >
        Kontrollo
      </Button>
    </div>
  );
};

export default ScanInput;
